import { utils, writeFileXLSX } from 'xlsx';

// ----------------------------------------------------------------------

export function exportJSONToExcel({
  data,
  headers,
  sheetname = 'Sheet1',
  filename = 'Book1.xlsx',
}) {
  const worksheet = utils.json_to_sheet(data);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, sheetname);

  if (headers) {
    utils.sheet_add_aoa(worksheet, headers, { origin: 'A1' });
  }

  writeFileXLSX(workbook, filename);
}
